// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b0369086","247":"2772ede6","256":"e4d0aeea","627":"7f2f5e88","867":"4a8bc760","923":"0f9d5764","938":"34506305"}[chunkId] + ".chunk.js";
};